import { Box, ThemeSwitcher } from 'pixelize-design-library';
import { useTranslation } from 'react-i18next';

interface ThemeToggleProps {
  variant?: 'icon' | 'segmented' | 'menu';
  size?: 'sm' | 'md' | 'lg';
}

/**
 * The library has no `ThemeToggle` — the component is `ThemeSwitcher`. This wrapper exists
 * so the app-wide variant/size is ONE decision; never render `ThemeSwitcher` directly.
 *
 * The `settings({ colorMode })` dispatch is NOT here. It hangs off the provider's
 * `onModeChange`, which fires on user intent only — reading `useThemeMode().mode` in an
 * effect and writing it back to the store is a mirror, and a mirror plus `defaultMode`
 * feeding the provider flips the two ends light/dark forever.
 */
export function ThemeToggle({ variant = 'icon', size = 'sm' }: ThemeToggleProps) {
  const { t } = useTranslation();
  return (
    <Box data-testid='theme-toggle'>
      <ThemeSwitcher variant={variant} size={size} aria-label={t('aria.toggleColourMode')} />
    </Box>
  );
}
